import React, { useState } from 'react';
import { MobileDrawBudgetCategory } from './MobileDrawBudgetCategory';
import { MobileDrawBudgetItem } from './MobileDrawBudgetItem/MobileDrawBudgetItem';
import { DrawBudgetLineCategory, DrawBudgetLineCategoryDescription } from '@apply/constants';
import { MobileDrawItem } from '../MobileDrawControl';

interface MobileDrawDetailsParameters {
    mobileDrawItems: MobileDrawItem[];
    hideFullyFunded: boolean;
    set_mobileBorrowerRequest: (drawItemId: number, borrowerRequest: number) => void;
}

export const MobileDrawDetails: React.FC<MobileDrawDetailsParameters> = ({
    mobileDrawItems,
    hideFullyFunded,
    set_mobileBorrowerRequest,
}) => {
    if (!mobileDrawItems) return;

    const categories = [...new Set(mobileDrawItems.map((item) => item.categoryId))];
    const [drawItemCalculationMetric, set_drawAmountCalculationMetric] = useState('percent');

    const availableAmountByCategory = (category: DrawBudgetLineCategory) => {
        const categoryAvailable = mobileDrawItems
            .filter((item) => item.categoryId == category)
            ?.reduce((sum, value) => (sum += value?.availableAmount ?? 0), 0);
        return categoryAvailable;
    };

    return categories.map((category) => (
        <div
            className={`mobileBudgetCategory ${availableAmountByCategory(category) <= 0 && hideFullyFunded ? 'hidden' : ''}`}
            key={category}
        >
            <MobileDrawBudgetCategory
                key={`budgetCategory${category}`}
                header={<h5>{DrawBudgetLineCategoryDescription[category]}</h5>}
            >
                <div className='mobileBudgetItemList'>
                    {mobileDrawItems
                        .filter((i) => i.categoryId == category)
                        .map((item) => (
                            <MobileDrawBudgetItem
                                key={`budgetItem${item.description}`}
                                mobileDrawItem={item}
                                set_mobileBorrowerRequest={set_mobileBorrowerRequest}
                                hideFullyFunded={hideFullyFunded}
                                drawItemCalculationMetric={drawItemCalculationMetric}
                                set_drawAmountCalculationMetric={set_drawAmountCalculationMetric}
                            />
                        ))}
                </div>
            </MobileDrawBudgetCategory>
        </div>
    ));
};
